import React from 'react';

import Row from '@visa/vds/row';
import MCSSpace from './MCSSpace';
import Progress from '@visa/vds/progress';

const MCSLoading = () => {

    return(
    
        
        <Row>
            <MCSSpace height="50px"></MCSSpace>
            <Progress style={{margin: "auto"}} type="spinner" />
        </Row>
  
    )

}

export default MCSLoading